import { reports } from 'constants/lists';

export const findsReportCategoriesByIds = ids => {
  const categories = reports.filter(r => ids.includes(r.value)).map(r => r.category);
  return [...new Set(categories)];
};
